import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle
} from '@dtx-company/design-system/src'
import React, { FC } from 'react'

export interface ConfirmationDialogProps {
  isOpen: boolean
  title: string
  description: string
  cancelText: string
  acceptText: string
  handleClose: () => void
  handleAccept: () => void
  handleCancel: () => void
  analyticsId?: string
}

export const ConfirmationDialog: FC<ConfirmationDialogProps> = ({
  isOpen,
  title,
  description,
  cancelText,
  acceptText,
  handleClose,
  handleAccept,
  handleCancel,
  analyticsId
}) => {
  return (
    <Dialog open={isOpen} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>{description}</DialogContent>
      <DialogActions>
        <Button
          variant="text"
          onClick={handleCancel}
          {...(analyticsId && { 'data-heap-id': `${analyticsId}_CancelButton` })}
        >
          {cancelText}
        </Button>
        <Button
          onClick={handleAccept}
          color="error"
          {...(analyticsId && { 'data-heap-id': `${analyticsId}_AcceptButton` })}
        >
          {acceptText}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
